export const FORMIK_EMPTY_VALUE = ''

export const FORMIK_SELECT_EMPTY_VALUE = null

export const SERVER_NON_FIELD_ERROR_KEY = 'non_field_error'

export const SERVER_NON_FIELD_ERROR_OLD_API_KEY = 'non_field_errors'

export const SERVER_ERROR_OBJECT_KEY = 'errors'

export const SERVER_ERROR_DETAIL_OBJECT_KEY = 'detail'

export const SERVER_ERROR_MESSAGE_KEY = 'message'

export const SERVER_ERROR_CONTEXT_KEY = 'ServerError'
